module.exports = __webpack_public_path__ + "static/media/Landscape-Autumn-leaf-litter-incineration.4ce2d077.jpg";